import Vue from 'vue'

// lodash
import _ from 'lodash'
window._ = _

// axios
import axios from './axios'
window.axios = axios

// moment
import moment from 'moment'
require('moment/locale/zh-tw')
moment.locale('zh-tw')
window.moment = moment
Vue.prototype.moment = moment

import $ from 'jquery'
window.$ = window.jquery = $
Vue.prototype.$ = $

// datatables
import dt from 'datatables.net-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-buttons/js/buttons.print.js'
window.dt = dt

// JSZip
import * as JSZip from 'jszip'
window.JSZip = JSZip

// Import datetimepicker
import datePicker from 'vue-bootstrap-datetimepicker'
Vue.use(datePicker)

// Import multiselect
import Multiselect from 'vue-multiselect'
Vue.component('multiselect', Multiselect)

// Import numeral
import numeral from 'numeral'
window.numeral = numeral
Vue.prototype.numeral = numeral


import VCharts from 'v-charts'
Vue.use(VCharts)

import VueDragDrop from 'vue-drag-drop'
Vue.use(VueDragDrop)
